<div #blockTarget>

  @if (!pluginCode && !showManualEditor) {
  <div class="row g-3 mb-4">
    <div class="col-md-4">
      <div
        class="drop-area h-100 p-4 border-2 border-dashed rounded-3 text-center bg-light d-flex flex-column justify-content-center align-items-center"
        style="cursor: pointer; transition: all 0.2s; border-color: #dee2e6;"
        onmouseover="this.style.borderColor='#007bff'; this.style.backgroundColor='#f1f8ff'"
        onmouseout="this.style.borderColor='#dee2e6'; this.style.backgroundColor='#f8f9fa'"
        (dragover)="$event.preventDefault()"
        (drop)="onDrop($event)"
        (click)="fileInput.click()"
      >
        <div
          class="text-primary mb-2"
          style="font-size: 1.5rem;"
        ><i class="ri-folder-upload-line"></i></div>
        <div class="fw-medium" i18n="@@plugin-upload-file">Datei hochladen</div>
        <div class="text-muted small" i18n="@@plugin-upload-file-hint">Plugin-Datei (.block) auswählen</div>
        <input
          #fileInput
          type="file"
          accept=".block"
          class="d-none"
          (change)="onFileSelected($event)"
        />
      </div>
    </div>
    <div class="col-md-4">
      <div
        class="h-100 p-4 border-2 border-dashed rounded-3 text-center bg-light d-flex flex-column justify-content-center align-items-center"
        style="cursor: pointer; transition: all 0.2s; border-color: #dee2e6;"
        onmouseover="this.style.borderColor='#007bff'; this.style.backgroundColor='#f1f8ff'"
        onmouseout="this.style.borderColor='#dee2e6'; this.style.backgroundColor='#f8f9fa'"
        (click)="showManualEditor = true"
      >
        <div
          class="text-primary mb-2"
          style="font-size: 1.5rem;"
        ><i class="ri-flashlight-line"></i></div>
        <div class="fw-medium" i18n="@@plugin-create-from-js">Aus JavaScript erstellen</div>
        <div class="text-muted small" i18n="@@plugin-create-from-js-hint">Code direkt einfügen</div>
      </div>
    </div>
  </div>
  }
  @if (showManualEditor && !pluginCode) {
  <div class="p-4 border rounded-3 bg-white mb-4 shadow-sm">
    <div class="
  d-flex
  justify-content-between
  align-items-center
  mb-3">
      <h6 class="fw-bold m-0">
        @if (editingPluginId) {
        <i class="ri-edit-line me-1"></i>
        <span i18n="@@plugin-edit-header">Plugin bearbeiten</span>
        } @else {
        <i class="ri-tools-line me-1"></i>
        <span i18n="@@plugin-generator-header">Plugin Generator</span>
        }
      </h6>
    </div>
    <div class="mb-3">
      <label class="small text-muted fw-bold" i18n="@@plugin-name-label">PLUGIN NAME</label>
      <input
        type="text"
        [(ngModel)]="myNewPluginName"
        class="form-control mt-1 shadow-sm"
        placeholder="z.B. MeinSpezialPlugin"
        i18n-placeholder="@@plugin-name-placeholder"
      >
    </div>
    <div class="mb-3">
      <label class="small text-muted fw-bold" i18n="@@plugin-js-code-label">JAVASCRIPT CODE</label>
      <app-codemirror-dann
        [code]="myNewJsCode"
        [rows]="6"
        (finish)="myNewJsCode = $event.code"
      ></app-codemirror-dann>
      <div class="text-end cursor-pointer">
        <a (click)="this.openBottly.emit()">
          <i class="botly"></i>
          <span i18n="@@ask-botly">Botly Fragen</span></a>
      </div>
    </div>
    <div class="d-flex gap-2">
      <button
        class="btn btn-primary px-4 fw-bold shadow-sm"
        (click)="generatePluginTemplate(myNewPluginName, myNewJsCode)"
      >
        <i class="ri-magic-line me-1"></i>
        @if (editingPluginId) {
        <span i18n="@@plugin-apply-changes-preview">Änderungen übernehmen & Vorschau</span>
        } @else {
        <span i18n="@@plugin-create-preview">Erstellen & Vorschau</span>
        }
      </button>
      <button
        class="btn btn-link text-muted text-decoration-none"
        (click)="cancelEdit()"
        i18n="@@cancel"
      >Abbrechen</button>
    </div>
  </div>
  }

  @if (pluginCode) {
  <div class="d-flex align-items-center  pb-2 ">
    <span>{{this.bps.getPluginName(pluginCode, editingPluginId)}}</span>
    @if (this.bps.pluginNameisTaken(this.bps.getPluginName(pluginCode, editingPluginId), editingPluginId)) {
    <span class="badge rounded-pill bg-danger ms-2" i18n="@@plugin-name-taken-badge"> Name bereits vergeben
    </span>
    }
  </div>
  <div class="d-flex  align-items-center gap-3   pt-3  border-bottom pb-3 mb-4">
    <button
      class="btn btn-primary px-4 fw-bold shadow-sm"
      [disabled]="this.bps.pluginNameisTaken(this.bps.getPluginName(pluginCode, editingPluginId), editingPluginId)"
      (click)="addPlugin()"
    >
      <i class="ri-download-cloud-2-line me-1"></i>
      @if (editingPluginId) {
      <span i18n="@@plugin-save-changes">Änderungen speichern</span>
      } @else {
      <span i18n="@@plugin-import-confirm">Import bestätigen</span>
      }
    </button>
    <button
      class="btn btn-link btn-sm text-muted text-decoration-none"
      (click)="cancelEdit()"
      i18n="@@cancel"
    >Abbrechen</button>
  </div>
  @let blocks = this.bps.getRawBlocks(pluginCode);
  <h5 i18n="@@plugin-blocks-count">Bereitgestellte Blöcke ({{blocks.length}}):</h5>
  <div style="max-height: calc(100% - 200px); overflow-y: auto;">
    @if (blocks; as blocks) {
    <div>
      @for (block of blocks; track block; let last = $last) {
      <div
        [class.mb-3]="!last"
        class="p-3 "
      >
        @let b = this.bps.parseBlockFileToObject(block);
        <input
          type="hidden"
          #showFullCode
          value="false"
        >
        <div class="row g-2">
          <div class="col border-end">
            <label class=" text-muted fw-bold d-block mt-1" i18n="@@plugin-block-label"><i class="ri-puzzle-line me-1"></i>Block</label>
            <code
              class="small text-dark border rounded bg-light d-inline-block p-1"
              [innerHTML]="this.formatPlaceholder(b.block)"
            ></code>
          </div>
          <div class="col ps-md-3">
            <div class="row small mt-1">
              <div class="col-4 text-muted" i18n="@@plugin-code-colon">code:</div>
              <div class="col-8 d-flex align-items-start gap-1">
                <code
                  class="text-dark bg-white px-1 border rounded"
                  [class.text-truncate]="showFullCode.value !== 'true'"
                  [style.max-width]="showFullCode.value === 'true' ? 'none' : '150px'"
                  [style.white-space]="showFullCode.value === 'true' ? 'pre-wrap' : 'nowrap'"
                  [style.display]="showFullCode.value === 'true' ? 'block' : 'inline-block'"
                >
                        {{ b.code }}
                      </code>
                <button
                  class="btn btn-xs p-0 lh-1 text-primary border-0 bg-transparent"
                  (click)="showFullCode.value = showFullCode.value === 'true' ? 'false' : 'true'"
                >
                  <i [class]="showFullCode.value === 'true' ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                </button>
              </div>
              <div class="col-4 text-muted mt-1" i18n="@@plugin-features-label">Features:</div>
              <div class="col-8 mt-1">{{ b.features || '-' }}</div>
              <div class="col-4 text-muted mt-1" i18n="@@plugin-nestings-label">Nestings:</div>
              <div class="col-8 mt-1 text-truncate">{{ b.nestings || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  }

  @if (!showManualEditor && !pluginCode && bps.pluginIdToNameMap) {
  <div class="mt-4">
    <label class="small text-muted fw-bold mb-3 d-block border-bottom pb-1" i18n="@@plugin-installed-label">INSTALLIERTE PLUGINS</label>
    @if ((bps.pluginIdToNameMap | keyvalue).length > 0) {
    <div class="d-flex flex-wrap gap-2">
      @for (key of (bps.pluginIdToNameMap | keyvalue:reverseOrder); track key) {
      <div
        class="d-flex align-items-center bg-white border rounded-pill ps-3 pe-2 py-1 shadow-sm transition-all"
        [class.border-danger]="confirmDelete.value === key.key"
      >
        <input
          type="hidden"
          #confirmDelete
          value=""
        >
        <span
          class="me-2 small fw-medium"
          [class.text-danger]="confirmDelete.value === key.key"
        >
          {{ confirmDelete.value === key.key ? pluginDeleteConfirmLabel : key.value }}
        </span>
        @if (confirmDelete.value !== key.key) {
        <button
          class="btn btn-sm p-0 text-primary border-0 bg-transparent me-2"
          (click)="editPlugin( key.key)"
          title="Plugin bearbeiten"
          i18n-title="@@plugin-edit-header"
        >
          <i class="ri-edit-line fs-6"></i>
        </button>
        }
        @if (confirmDelete.value !== key.key) {
        <button
          class="btn btn-sm p-0 text-primary border-0 bg-transparent me-2"
          (click)="pluginDownload( key.key)"
          title="Plugin herunterladen"
          i18n-title="@@plugin-download-tooltip"
        >
          <i class="ri-download-2-line fs-6"></i>
        </button>
        }
        @if (confirmDelete.value !== key.key) {
        <button
          class="btn btn-sm p-0 text-danger border-0 bg-transparent"
          [ngClass]="{'d-none': this.bps.pluginUsage(key.key, bss.stages)  > 0}"
          (click)="confirmDelete.value = key.key"
        >
          <i class="ri-delete-bin-line fs-6"></i>
        </button>
        }
        @if (this.bps.pluginUsage(key.key, bss.stages) > 0) {
        <span class="badge badge-info bg-secondary" i18n="@@plugin-in-use-badge">In Verwendung</span>
        }
        @if (confirmDelete.value === key.key) {
        <div class="d-flex gap-1">
          <button
            class="btn btn-xs btn-danger rounded-pill px-2 py-0"
            style="font-size: 0.7rem;"
            (click)="removePlugin(key.key)"
            i18n="@@delete"
          >Löschen</button>
          <button
            class="btn btn-xs btn-light border rounded-pill px-2 py-0"
            style="font-size: 0.7rem;"
            (click)="confirmDelete.value = ''"
            i18n="@@cancel"
          >Abbrechen</button>
        </div>
        }
      </div>
      }
    </div>
    } @else {
    <div class="text-muted small fst-italic p-2" i18n="@@plugin-empty-state">Noch keine Plugins installiert. Erstelle dein erstes Plugin.</div>
    }
  </div>
  }
</div>